/* eslint-disable @typescript-eslint/no-unused-vars */
import { NotificaInApp, sharedActions } from '@ideapa/app-shared-notifica';
import { NotificaWithCounter } from '@ideapa/common-dto';
import { createReducer, on } from '@ngrx/store';
import * as Actions from './notifications.actions';

export const NOTIFICATIONS_FEATURE_KEY = 'notifications';

export interface NotificationsPartialState {
  readonly [NOTIFICATIONS_FEATURE_KEY]: NotificationsState;
}

export interface NotificationsState {
  notifications: NotificaInApp[];
  isLoaded: boolean;
  unreadCount: number;
}

const initialState: NotificationsState = {
  notifications: [],
  isLoaded: false,
  unreadCount: 0,
};

export const reducer = createReducer(
  initialState,
  on(Actions.getUserLatestNotificationsSuccess, (state, { items, counter }) => {
    return {
      ...state,
      notifications: items,
      isLoaded: true,
      unreadCount: counter,
    };
  }),
  on(sharedActions.loadSingleSuccess, (state, { item }) => {
    return {
      ...state,
      notifications: state.notifications.map((n) => {
        if (item.id === n.id) {
          return { ...n, stato: item.stato };
        }
        return n;
      }),
      unreadCount: (<NotificaWithCounter>item).unreadCount,
    };
  }),
  on(Actions.getUserLatestNotificationsFailure, (state, { error }) => {
    return {
      ...state,
      isLoaded: true,
    };
  })
);
